import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import useWebContext from '../../hooks/useWebContext';
import Grid from '@mui/material/Grid';

export const ServiceLv2SubLv2PreparationTabContents = (
  {
    visible,
    screenId,
    metadata,
    isPc
  }) => {

  const { controlSettings } = useWebContext(screenId);
  const navigate = useNavigate();
  const labelPadding = isPc ? '20px 50px 10px 300px' : '20px 10px 0 10px';
  const buttonLeft = isPc ? '60%' : '-30px';

  if (!visible) {
    return <></>
  }

  return (
    <Grid className='p-3' spacing={3} container>
      <MyMLabel sx={{ fontWeight: 'bold', width: 'fit-content', padding: labelPadding, textAlign: 'center', left: '20%' }}>
        {controlSettings.LabelList['lblContentsDescription_' + metadata.MetadataId]}
      </MyMLabel>
      <Grid container>
        <Grid item xs={6} />
        <Grid item xs={6}>
          <MyMButton
            sx={{
              width: '200px',
              backgroundColor: '#eeeeee !important',
              color: 'black !important',
              left: buttonLeft, 
            }}
            onClick={() => navigate('MyM317')}
          >
            {controlSettings.LabelList.btnTraining}</MyMButton>
        </Grid>
      </Grid>

    </Grid>
  );
}